// extracted by mini-css-extract-plugin
export default {"_":"loading____EhWlo","_2":"loading__2__sgwhP","fan":"loading_fan__7wFH4","circle-to-square":"loading_circle-to-square__cxcUU"};